import request from "@/common/request"
import { RegraFiscal } from "@/models/fiscal/RegrasFiscais"


const basePath = '/regras-fiscais'

export const findRegrasFiscais = async (): Promise<RegraFiscal[]> =>
	request.get(`${basePath}`)

export const deleteRegrasFiscais = async (regraFiscal: RegraFiscal): Promise<void> =>
	request.delete(`${basePath}`, {
		data: regraFiscal,
	});

export const saveRegrasFiscais = async(regraFiscal: RegraFiscal): Promise<void> => 
	request.post(`${basePath}/criarRegra`,
		regraFiscal,
	)	

